import BaseApi from "./base";

class CitasApi extends BaseApi {
  constructor() {
    super("citas");
  }
}

export default new CitasApi();
